import angular from 'angular'

const listCtrl = require('./registrationCodeManagementListCtrl')
const modalPageCtrl = require('./modalPageCtrl')

const listPage = require('./views/registrationCodeManagementList.html')

function config($stateProvider) {
    $stateProvider
        .state('system.permission.registrationCodeManagement', {
            url: '/registrationCodeManagement',
            template: '<div ui-view></div>',
            title: '注册码管理',
            abstract: true,
            default: 'system.permission.registrationCodeManagement.list',
        })
        .state('system.permission.registrationCodeManagement.list', {
            url: '/list',
            controller: 'registrationCodeManagementListCtrl',
            template: listPage,
        })
}

export default angular
    .module('system.permission.registrationCodeManagement', [])
    .config(['$stateProvider', config])
    .controller('modalPageCtrl', modalPageCtrl.default)
    .controller('registrationCodeManagementListCtrl', listCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/permission/registrationCodeManagement/index.js